"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontSizeBaseline = void 0; // .......... BASELINE FONT SIZE .......... //

var fontSizeBaseline = 16;
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.fontSizeBaseline = fontSizeBaseline;